import { Component, OnInit } from '@angular/core';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Angular2CsvModule } from 'angular2-csv';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';
//import { timingSafeEqual } from 'crypto';
@Component({
  selector: 'app-social-security',
  templateUrl: './social-security.component.html',
  styleUrls: ['./social-security.component.css']
})
export class SocialSecurityComponent implements OnInit {
  isShow : string ='hide';
  scheme : string='';
  accountNo : string ='';
  cifNo : string ='';
  nomName : string ='';
  nomRelation : string ='';
  disabled : boolean =false;
  isLoad : boolean =false;
  getCustomerDetailsData : any ;
  getCustomerDetailsResp : any ;
  customerDetails : any ;
  isError : string ='';
  otp : string ='';
  socialSecuritySchemesResp : any ;
  nomNameblank : string ='';
  desabled : boolean =false;
  nomNameSpace : string ='';
  nomNameSpeci : string ='';
  nomNamelength : string ='';
  nicknameNotNumber : string ='';
  nicknameblank : string ='';
  getJointHoldersResp : any;
  jointHolderDetails : any;
  userName : string='';
  custNo : string='';
  scoAccounts : any;
  storedOtp : string='';
  otpInvalid : string='';
  otpBlank : string;
  schemeRequired:string="";
  accNoRequired:string="";
  CIFNoRequired:string="";
  disableNextBtn1:boolean=false;
  disablesubBtn:boolean=false;
  disableNextBtn2:boolean=false;
  otpRequired:string='';
  nrelatRequired:string='';
  error:string='';
  isError1:boolean=false;
  SuccessMessage:string="";
  nomAge: number;
  nomAgeblank: string;
  bankName: any;

  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) {
    this.bankName = webService.getBankName();
    this.userName =sessionStorage.getItem('storedUserName');
    this.custNo =sessionStorage.getItem('custNo');
    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    // const request: IbRequest = new IbRequest();
    // let response: IbResponse = null;
    // request.param1 = getHexAscii("",this.custNo);
    // request.param2 = this.custNo;
    // this.spinnerService.show();
    // this.webService.getResponse(request, 'getJointHolders').subscribe((data: IbResponse) => {
    //   this.isLoad=false;
    //   this.spinnerService.hide();
    //   this.getJointHoldersResp=data;
    //   if (this.getJointHoldersResp.status === 'S101'){
    //     alert('Malicious Request Detected');
    //   }
    //   if(this.getJointHoldersResp.status==='S200'){
    //     this.jointHolderDetails=this.getJointHoldersResp.param6;
    //   }
    // });
  }
  getCustomerDetails()
  {
    if(this.scheme===""||this.scheme===" "||this.scheme===undefined){
      this.schemeRequired="no";
    }else if(this.accountNo===""||this.accountNo===" "||this.accountNo===undefined){
      this.accNoRequired='no';
    }else if(this.cifNo===""||this.cifNo===""||this.cifNo===undefined){
      this.CIFNoRequired="no";
    }else{
      this.disableNextBtn1=true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;

      if(this.userName && this.custNo && this.scheme && this.accountNo && this.cifNo){

        this.disabled=true;
        this.isLoad=true;
         this.spinnerService.show();
        request.param1 = getHexAscii("",this.custNo+this.userName+this.accountNo),
          request.param2 = this.custNo,
          request.param3 = this.userName,
          request.param4 = this.accountNo;


        this.webService.getResponse(request, 'customerAddress').subscribe((data: IbResponse) => {
          this.isLoad=false;
          this.spinnerService.hide();
          this.getCustomerDetailsResp=data;
          if (this.getCustomerDetailsResp.status === 'S101'){
            alert('Malicious Request Detected');
          }
          if(this.getCustomerDetailsResp.status==='S200'){
            //this.getCustomerDetailsResp=getCustomerDetailsResp;
            this.customerDetails=this.getCustomerDetailsResp.param5;
            this.isShow='showDetails';

          }
          else{
            this.disableNextBtn1=false;
          }
        });
      }
    }
  }

  validateNomAge(){
    console.log('fIn works');
    if(this.nomAge==undefined){
     this.nomAgeblank='no';
     return false;
      }else if(this.nomAge==0){
        this.nomAgeblank='zeroAge';
        return false;
      }else{
        this.nomAgeblank='';
        return true;
      }
  }
  removeNomAgeMessage(){
    console.log('fout works');
    this.nomAgeblank='';
  }
  getOtp()
  {
	 console.log("In Method");
	var reg1=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    var regNum1 = /^.*[0-9]/;
	//var regexpspac1=/\s+/;
	console.log(this.nomName);
    if(this.nomName===""||this.nomName===" "||this.nomName===undefined){
		 console.log("1");
      this.nomNameblank="no";
    }
    else if(this.nomName.match(reg1))
    {
		 console.log("3");
      this.nomNameSpeci='no';
    }
    else if(this.nomName.length>20)
    {
		 console.log("4");
      this.nomNamelength='no';
    }
    else if(this.nomName.match(regNum1))
    {
		 console.log("5");
      this.nicknameNotNumber='no';
    }else if(this.nomRelation===""||this.nomRelation===" "||this.nomRelation===undefined){
		 console.log("6");
      this.nrelatRequired='no';
    }else{


	 console.log("Callwb");
      this.disableNextBtn2=true;
      this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      //  if(this.userName && this.scheme && this.accountNo && this.cifNo && this.nomName && this.nomRelation){
      this.disabled=true;
      this.isLoad=true;
      request.param1 = getHexAscii("",this.userName);
      request.param2 = this.userName;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        this.isLoad=false;
        this.spinnerService.hide();
        this.getCustomerDetailsResp=data;
        if (this.getCustomerDetailsResp.status === 'S101'){
          alert('Malicious Request Detected');
        }
        if(this.getCustomerDetailsResp.status==='S200'){
          this.isShow='show';
          this.storedOtp=this.getCustomerDetailsResp.param1;
          // console.log('Otp :'+this.getCustomerDetailsResp.param1);

        }
        else{
          this.disableNextBtn2=false;
        }
      });
      //}
    }

  }

  saveScheme()
  {
    if(this.otp===""||this.otp==="  "||this.otp===undefined)
    {
      this.otpRequired='no';
    }
    else{
      this.disablesubBtn=true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isError='';
      //  if(this.userName && this.scheme && this.accountNo && this.cifNo && this.nomName && this.nomRelation){
      this.disabled=true;
      this.spinnerService.show();
      this.isShow='show';
      var otpDetails={
        'userName' : this.userName,
        'otp' :getHexAscii("", this.otp),
        'custNo' : this.custNo,
        'nomineeName' : this.nomName,
        'nomineeRelation' : this.nomRelation
      };
      //alert(($rootScope.custNo+this.mobileNo+this.emailId+$rootScope.userName+this.otp));

      request.param1 = getHexAscii("",this.accountNo+this.scheme+this.cifNo+this.userName+this.otp+this.custNo+this.nomName+this.nomRelation),
        request.param2 = this.accountNo,
        request.param3 = this.scheme,
        request.param4 = this.cifNo,
        request.param6 = otpDetails;
      /*  if(this.otp===''|| this.otp === undefined)
          {
          this.otpBlank='no';
        }
         if(this.otp!==this.storedOtp)
          {
          this.otpInvalid='no';
        }
         else{*/
      this.webService.getResponse(request, 'socialSecuritySchemes').subscribe((data: IbResponse) => {
        this.isLoad=false;
        this.spinnerService.hide();
        this.socialSecuritySchemesResp=data;
        if (this.socialSecuritySchemesResp.status === 'S101'){
          alert('Malicious Request Detected');
          this.disablesubBtn=false;
        }
        if(this.socialSecuritySchemesResp.status==='S200'){

		  console.log('Otp :'+this.socialSecuritySchemesResp.param1);
		  this.isShow='success';
		  this.SuccessMessage=this.socialSecuritySchemesResp.param1;

        }else{
          this.disablesubBtn=false;
          this.error=data.param1;
          this.isError1=true;
        }
      });
      //}
    }
    //}
  }
  back()
  {

    this.disabled=false;
    this.otp='';
    this.nomName='';
    this.nomRelation='';
    this.isShow='hide';
    this.disableNextBtn1=false;
  }
  back1()
  {

    this.isShow='showDetails';
    this.otp='';
    this.disableNextBtn2=false;
    this.error='';
  }
  validateNomName()
  {

    var reg=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    var regNum = /^.*[0-9]/;
    var regexpspace=/\s+/;
    console.log("nominee name"+this.nomName);
    if(this.nomName===undefined || this.nomName===""||this.nomName==="  ")
    {
      this.nomNameblank='no';
      this.desabled=true;
    }
    else if(this.nomName.match(reg))
    {
      this.nomNameSpeci='no';
      this.desabled=true;
    }
    else if(this.nomName.length>20)
    {
      this.nomNamelength='no';
      this.desabled=true;
    }
    else if(this.nomName.match(regNum))
    {
      this.nicknameNotNumber='no';
      this.desabled=true;
    }
  }
  removeNomNameMessage()
  {
    this.nicknameblank='';
    this.nomNameSpace='';
    this.nomNameblank='';
    this.nomNameSpeci='';
    this.nomNamelength='';
    this.nicknameNotNumber='';
    this.desabled=false;
  }
  ngOnInit() {
   }
  removeSchemeMessages(){
    this.schemeRequired="";
  }
  removeAccNoMessages(){
    this.accNoRequired="";
  }
  removeCifMessages(){
    this.CIFNoRequired="";
  }
  removeRelatMsgs(){
    this.nrelatRequired="";
  }
  validateOtp()
  {
    if(this.otp===""||this.otp==="  "||this.otp===undefined)
    {
      this.otpRequired='no';
    }
  }

  removeOtpMsgs()
  {
    this.otpRequired='';
  }
  validateScheme()
  {
    if(this.scheme===""||this.scheme===" "||this.scheme===undefined){
      this.schemeRequired="no";
    }
  }

  validateAccountNoAndGetJointHold()
  {
    if(this.accountNo===""||this.accountNo===" "||this.accountNo===undefined){
      this.accNoRequired='no';
    }else{
      const request: IbRequest = new IbRequest();
    request.param1 = getHexAscii("",this.custNo+this.accountNo);
    request.param2 = this.custNo;
    request.param3 = this.accountNo;
    this.spinnerService.show();
    this.webService.getResponse(request, 'getJointHolders').subscribe((data: IbResponse) => {
      this.isLoad=false;
      this.spinnerService.hide();
      this.getJointHoldersResp=data;
      if (this.getJointHoldersResp.status === 'S101'){
        alert('Malicious Request Detected');
      }
      if(this.getJointHoldersResp.status==='S200'){
        this.jointHolderDetails=this.getJointHoldersResp.param6;
      }
    });
    }
  }
  validateAccountNo()
  {
    if(this.accountNo===""||this.accountNo===" "||this.accountNo===undefined){
      this.accNoRequired='no';
    }
  }
  validateCIFNo()
  {
    if(this.cifNo===""||this.cifNo===""||this.cifNo===undefined){
      this.CIFNoRequired="no";
    }
  }
  validateRelation()
  {
    if(this.nomRelation===""||this.nomRelation===" "||this.nomRelation===undefined){
      this.nrelatRequired='no';
    }
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/social-security/social-security.component.ts